import { ApiResponse, useApiHook } from "@bjsdistribution/tms-component-library";
import React, { useEffect } from "react";
import DetailPage from "./DetailPage";

const Temporary = () => {
  const path = window?.location.pathname;
  const encodedString = path.split("/").pop();

  const {
    data: fetchedData,
    loading: apiLoading,
    fetchData,
  } = useApiHook<{
    data: ApiResponse[];
  }>({
    endpoint: `vehicle_maintenance/decode-defect-data/${encodedString}`,
    method: "GET",
  });
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (fetchedData) {
      //@ts-ignore
      const requiredData = fetchedData?.workshop_id;
      console.log("requiredData", requiredData);
    }
  }, [apiLoading]);
  return (
    <div>
      <DetailPage fetchedData={fetchedData} />
    </div>
  );
};

export default Temporary;
